import App from '../app'

export default {
    errors: {
        /**
         * Get first Laravel error message.
         */
        first(error) {
            let errors = _.get(error, "response.data.errors", []);

            if (errors.length > 0) {
                for (let index in errors) {
                    return _.first(errors[index]);
                }
            } else {
                return _.get(
                    error,
                    'response.data.error',
                    'Произошла непредвиденная ошибка'
                );
            }
        }
    },
    load(promise, keep = false, snackbar = {}) {
        let loading = App.$loading.open();

        if (Array.isArray(promise)) {
            promise = Promise.all(promise)
        }

        promise.then(response => {
            if (!keep) {
                loading.close();
            }
        }).catch(error => {
            loading.close();

            if (_.isNull(snackbar) == false) {
                let options = _.merge({
                    message: this.errors.first(error),
                    type: 'is-danger',
                }, snackbar);

                App.$snackbar.open(options);
            }
        })

        return promise
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/helpers.js